module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper",
    staticStyle: {
      "min-height": "870px"
    }
  }, [_c('div', {
    staticClass: "fade-transition"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("Assunto")]), _vm._v(" "), _c('b-breadcrumb', {
    attrs: {
      "items": [{
        text: 'Inicial',
        href: '/'
      }, {
        text: 'Cadastro',
        href: '#'
      }, {
        text: 'Assunto',
        active: true
      }]
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {}, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.show),
      expression: "loading.show"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "name": "frmRegNotice",
      "novalidate": "",
      "_lpchecked": "1"
    }
  }, [_c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('numeroEdital')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2",
    attrs: {
      "for": "assunto"
    }
  }, [_vm._v("Assunto:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.assunto.assunto),
      expression: "assunto.assunto"
    }],
    staticClass: "form-control ",
    attrs: {
      "name": "assunto",
      "type": "text",
      "minlength": "1",
      "ng-maxlength": "255"
    },
    domProps: {
      "value": (_vm.assunto.assunto)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.assunto, "assunto", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('numeroEdital')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('assunto')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('area_responsavel')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2",
    attrs: {
      "for": "area_responsavel"
    }
  }, [_vm._v("Área Responsável:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": _vm.areas,
      "multiple": false,
      "close-on-select": true,
      "clear-on-select": false,
      "hide-selected": false,
      "preserve-search": true,
      "placeholder": "Selecione uma área",
      "custom-label": _vm.etiquetaArea,
      "preselect-first": false,
      "selectLabel": "",
      "label": "nome",
      "track-by": "nome",
      "deselectLabel": "",
      "selectedLabel": "Selecionado",
      "name": "area_responsavel",
      "data-vv-as": "area_responsavel",
      "disabled": false
    },
    on: {
      "select": function($event) {
        return _vm.changeArea($event)
      }
    },
    model: {
      value: (_vm.assunto.area_responsavel),
      callback: function($$v) {
        _vm.$set(_vm.assunto, "area_responsavel", $$v)
      },
      expression: "assunto.area_responsavel"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noOptions"
    },
    slot: "noOptions"
  }, [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("Nenhum registro localizado!")])], 1)]), _vm._v(" "), (_vm.errors.first('parametroEdital')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('parametroEdital')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('status')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2",
    attrs: {
      "for": "bt_ativo"
    }
  }, [_vm._v("Ativo:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {
    staticClass: "radio-inline new-control new-control-radio"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.assunto.bt_ativo),
      expression: "assunto.bt_ativo"
    }],
    attrs: {
      "type": "radio",
      "name": "status",
      "id": "status",
      "checked": "",
      "value": "1"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.assunto.bt_ativo, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.assunto, "bt_ativo", 1)
      }
    }
  }), _vm._v(" Sim\n                      "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline new-control new-control-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.assunto.bt_ativo),
      expression: "assunto.bt_ativo"
    }],
    attrs: {
      "type": "radio",
      "name": "status",
      "id": "status",
      "value": "0"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.assunto.bt_ativo, 0)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.assunto, "bt_ativo", 0)
      }
    }
  }), _vm._v(" Não\n                      "), _c('div', {
    staticClass: "new-control-indicator"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('g-button-moema', {
    attrs: {
      "color": "primary",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.salva($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Salvar")]), _vm._v(" "), _c('g-button-moema', {
    attrs: {
      "color": "warning",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Voltar ")])], 1)])])])])])]), _vm._v(" "), _c('vue-snotify')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Editando Cadastro de Assunto")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-35df74a0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cadastro/assunto/EditarAssunto.vue
// module id = 1907
// module chunks = 1